// generated file, if you want to edit this file manually change the word "generated" to "manual"
import React from "react";
import clsx from "clsx";
import { makeThemedStyles } from "./../utils";
import MaterialAppBar from "@material-ui/core/AppBar";
import { excludeKeys } from "./../utils";
const useStylesForQPRAppBar = makeThemedStyles("QPRAppBar", (theme) => ({
  QPRAppBar: {},
}));
type PropType = React.ComponentProps<typeof MaterialAppBar>;
export const QPRAppBar: React.FunctionComponent<PropType> = (
  props: PropType
) => {
  const styles = useStylesForQPRAppBar();
  const enabledClasses = excludeKeys(styles, [
    "QPRAppBar",
    "ToolBar",
    "AppBarImage",
  ]);
  /* eslint-disable */
  return (
    <MaterialAppBar
      {...props}
      classes={{
        root: styles.QPRAppBar,
        ...enabledClasses,
      }}
      className={clsx(styles.QPRAppBar)}
    >
      {props?.children}
    </MaterialAppBar>
  );
};
export default QPRAppBar;
